import { useContext } from '@/compat';
import { DialogColors } from '../../../components/dialogs/constants';

const useToast = () => {
  const { $root } = useContext();

  const warning = async message => $root.$toast(message, { color: DialogColors.WARNING });

  const error = async message => $root.$toast(message, { color: DialogColors.ERROR });

  const success = async message => $root.$toast(message, { color: DialogColors.SUCCESS });

  const info = async message => $root.$toast(message, { color: DialogColors.INFO });

  const primary = async message => $root.$toast(message, { color: DialogColors.PRIMARY });

  return {
    warning,
    error,
    success,
    info,
    primary,
  };
};

export default useToast;
